import { TOKEN_KEY } from "@/variables";

// 判断是否为微信环境
// (): boolean
export const isWeixin = () =>
  !!window.navigator.userAgent.toLowerCase().includes("micromessenger");

export const isXCS = () =>
    !!window.navigator.userAgent.toLowerCase().includes("apptoken/");
// 获取 URL 搜索参数值
// (p: string): string
export const getSearchParam = (param = "") =>
  window.location.search
    .substring(1)
    .split("&")
    .map((e) => e.split("="))
    .find(([k]) => k === param)
    ?.pop() || "";

// 获取 Code 参数
// (p: string): string
export const getCode = (param = "code") => getSearchParam(param);

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

export const getOpenId = () => localStorage.getItem("huozhewang_openId");
export const setOpenId = (openId = "") =>
  localStorage.setItem("huozhewang_openId", openId);
export const getAccessToken = () =>
  localStorage.getItem("huozhewang_accessToken");
